const lang = {
  availableLocales: ["bg", "cs", "de", "el", "en", "es", "fr", "he", "hr", "hu", "it", "pl", "ro", "sk", "sl", "tr"],
  accountLocaleOptions: [
    { label: "Deutsch", value: "de" },
    { label: "English", value: "en" },
    { label: "Español", value: "es" },
    { label: "Français", value: "fr" },
    { label: "עִברִית", value: "he" },
    { label: "Hrvatski", value: "hr" },
    { label: "Italiano", value: "it" },
    { label: "Magyar", value: "hu" },
    { label: "Polskie", value: "pl" },
    { label: "Română", value: "ro" },
    { label: "Slovenský", value: "sk" },
    { label: "Slovenščina", value: "sl" },
    { label: "Čeština", value: "cs" },
    { label: "Ελληνικά", value: "el" },
    { label: "Български", value: "bg" },
    { label: "Türkçe", value: "tr" },
  ],
};

export default lang;
